import moment from 'moment'
import Vuex from 'vuex'
import api from '@/api'
import Vue from 'vue'

import packinglists from './packinglists'
import attachments from './attachments'
import materials from './materials'
import metrics from './metrics'
import clients from './clients'
import listes from './listes'
import companies from './masters/companies'
import status from './masters/status'
import reasons from './masters/reasons'
import roles from './masters/roles'
import trucks from './trucks'
import receptions from './receptions'
import expeditions from './expeditions'
import shipments from './shipments'
import restrictedDates from './restricted-dates'
import criticalLines from './critical-lines'
import historic from './historic'
import works from './works'
import worksheets from './worksheets'
import workDescriptions from './work-descriptions'
import auth from './auth'
import user from './user'

Vue.use(api)
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    notification: {
      group: 'global', duration: 3000
    },
    pageSize: 30,
    successMessage: {}
  },
  modules: {
    packinglists: packinglists,
    attachments: attachments,
    materials: materials,
    metrics: metrics,
    clients: clients,
    listes: listes,
    companies: companies,
    status: status,
    reasons: reasons,
    roles: roles,
    trucks: trucks,
    receptions: receptions,
    expeditions: expeditions,
    shipments: shipments,
    restrictedDates: restrictedDates,
    criticalLines: criticalLines,
    historic: historic,
    works: works,
    worksheets: worksheets,
    workDescriptions: workDescriptions,
    auth: auth,
    user: user
  },
  mutations: {
    'API_REQUEST' (state) {
      state.errorMessage = null
      state.request_start = true
      state.request_success = false
      state.request_error = false
    },
    'API_REQUEST_SUCCESS' (state, payload) {
      state.request_success = true
      state.request_start = false
    },
    'API_REQUEST_ERROR' (state, payload) {
      Object.assign(payload, { group: 'global', type: 'error', duration: 4000 })
      state.notification = payload
      state.request_error = true
      state.request_start = false
    }
  },
  actions: {
    async request ({ commit, state, getters, rootState }, config) {
      commit('API_REQUEST')
      var url = `${getters.apiURL}${config.url}/`
      var headers = getters.apiHeaders
      if (config.url.indexOf('token') < 0 && config.url.indexOf('auth') < 0) {
        headers = Object.assign({}, headers, {'company': state.auth.company})
      }
      return api.request(config.method, headers, url, config.data, config.params
      ).then(response => {
        commit('API_REQUEST_SUCCESS', response.data)
        return response
      }).catch(error => {
        commit('API_REQUEST_ERROR', {
          title: 'ERROR',
          type: 'error',
          text: apiErrorToHTML((error.response) ? error.response.data : error.response, this)
        })
        if (error && error.response && error.response.data && error.response.data.code === 'token_not_valid') {
          return error.response.data.code
        }
        throw error
      })
    },
    async contact ({ commit, state, getters, rootState }, config) {
      commit('API_REQUEST')
      return api.contact(config).then(response => {
        commit('API_REQUEST_SUCCESS', response.data)
        return response
      }).catch(error => {
        commit('API_REQUEST_ERROR', {
          duration: config.duration,
          title: 'ERROR',
          type: 'error',
          text: apiErrorToHTML(error.response.data)
        })
        throw error
      })
    },
    async multipartRequest ({ commit, state, getters, rootState }, config) {
      commit('API_REQUEST')
      var url = `${getters.apiURL}${config.url}/`
      return api.multipartRequest(config.method, getters.apiHeaders, url, config.data, config.params
      ).then(response => {
        commit('API_REQUEST_SUCCESS', response.data)
        return response
      }).catch(error => {
        commit('API_REQUEST_ERROR', {
          title: 'ERROR',
          type: 'error',
          text: apiErrorToHTML((error.response) ? error.response.data : error.response, this)
        })
        throw error
      })
    },
    async export ({ commit, state, getters, rootState }, config) {
      commit('API_REQUEST')
      var url = `${getters.apiURL}${config.url}/`
      var headers = getters.apiHeaders
      if (config.url.indexOf('token') < 0 && config.url.indexOf('auth') < 0) {
        headers = Object.assign({}, headers, {'Authorization': 'Token ' + state.auth.token, 'company': state.auth.company})
      }
      return api.download('get', headers, url, null, config.params// , config.data
      ).then(response => {
        // commit('API_REQUEST_SUCCESS', response)
        return response
      }).catch(error => {
        if (config.url !== 'api/userProject') {
          commit('API_REQUEST_ERROR', {
            title: 'ERROR',
            type: 'error',
            text: apiErrorToHTML((error.response) ? error.response.data : error.response, this)
          })
        }
        throw error
      })
    },
    async downloadFiles ({ commit, state, getters, rootState }, config) {
      commit('API_REQUEST')
      var url = `${getters.apiURL}${config.url}/`
      if (url.indexOf('download') < 0) {
        url = `${url}${config.id}/download/`
      }
      var headers = getters.apiHeaders
      if (config.url.indexOf('token') < 0 && config.url.indexOf('auth') < 0) {
        headers = Object.assign({}, headers, {'company': state.auth.company})
      }
      return api.download('get', headers, url, undefined, config.params // , config.data, config.params
      ).then(response => {
        // commit('API_REQUEST_SUCCESS', response)
        return response
      }).catch(error => {
        if (config.url !== 'api/userProject') {
          commit('API_REQUEST_ERROR', {
            title: 'ERROR',
            type: 'error',
            text: apiErrorToHTML((error.response) ? error.response.data : error.response, this)
          })
        }
        throw error
      })
    },
    async downLoadCheck ({ commit, state, getters, rootState }, config) {
      commit('API_REQUEST')
      var url = `${getters.apiURL}${config.url}/${config.id}/download_checklist/`

      var headers = getters.apiHeaders
      if (config.url.indexOf('token') < 0 && config.url.indexOf('auth') < 0) {
        headers = Object.assign({}, headers, {'company': state.auth.company})
      }
      return api.downloadFile('get', headers, url// , config.data, config.params
      ).then(response => {
        // commit('API_REQUEST_SUCCESS', response)
        return response
      }).catch(error => {
        if (config.url !== 'api/userProject') {
          commit('API_REQUEST_ERROR', {
            title: 'ERROR',
            type: 'error',
            text: apiErrorToHTML((error.response) ? error.response.data : error.response, this)
          })
        }
        throw error
      })
    },
    async list ({ dispatch, commit, state }, config) {
      var params = {}

      if (config.params) {
        params = JSON.parse(JSON.stringify(config.params))
        if (params.date_end) params.date_end = moment(params.date_end).add('day', 1).format('YYYY-MM-DD')
        if (params.booked_date_after) params.booked_date_after = moment(params.booked_date_after).startOf('day').format('YYYY-MM-DDTHH:mm')
        if (params.booked_date_before) params.booked_date_before = moment(params.booked_date_before).endOf('day').format('YYYY-MM-DDTHH:mm')
        if (params.register_date_after) params.register_date_after = moment(params.register_date_after).startOf('day').format('YYYY-MM-DDTHH:mm')
        if (params.register_date_before) params.register_date_before = moment(params.register_date_before).endOf('day').format('YYYY-MM-DDTHH:mm')
        if (params.end_date_after) params.end_date_after = moment(params.end_date_after).startOf('day').format('YYYY-MM-DDTHH:mm')
        if (params.end_date_before) params.end_date_before = moment(params.end_date_before).endOf('day').format('YYYY-MM-DDTHH:mm')
      }

      try {
        const response = await dispatch('request', {
          method: 'get',
          url: config.basePath,
          params: params
        })

        if (response.status === 204) {
          return {count: 0, results: []}
        }

        const count = 'count' in response.data ? response.data.count : response.data.length
        const results = 'results' in response.data ? response.data.results : response.data
        return {count: count, results: results}
      } catch (error) {
        throw error
      }
    },
    async read ({ dispatch, commit, state }, config) {
      var url = `${config.basePath}/${config.id}`
      if (!config.id) {
        return undefined
      }
      return dispatch('request', {method: 'get', url: url})
        .then(response => { return response.data })
        .catch(error => { throw error })
    },
    async save ({ dispatch, commit, state, rootState }, config) {
      var url = config.basePath
      var method = 'post'
      if (config.id > 0) {
        url = `${url}/${config.id}`
        method = 'put'
      }
      return dispatch('request', { method: method, url: url, data: config.data })
        .then(response => {
          state.object = response.data
          return state.object
        }).catch(error => {
          throw error
        })
    },
    async patch ({ dispatch, commit, state, rootState }, config) {
      var url = config.basePath
      var method = 'patch'
      if (config.id > 0) {
        url = `${url}/${config.id}`
      }
      return dispatch('request', { method: method, url: url, data: config.data })
        .then(response => {
          state.object = response.data
          return state.object
        }).catch(error => {
          throw error
        })
    },
    async delete ({ dispatch, commit, state, rootState }, config) {
      const ModelClass = config.modelClass
      const url = `${config.basePath || ModelClass.defaults().basePath}/${config.id}`

      try {
        const response = await dispatch('request', { method: 'delete', url, data: config.data })
        state.object = response.data
        return response.data
      } catch (error) {
        throw error
      }
    },

    async requestIndicators ({ commit, state, getters, rootState }, config) {
      commit('API_REQUEST')
      var url = `${getters.indicatorsApi}${config.url}/`
      var headers = Object.assign({}, getters.indicatorsHeaders, config.headers)
      return api.request(config.method, headers, url, config.data, config.params
      ).then(response => {
        commit('API_REQUEST_SUCCESS', response.data)
        return response.data
      }).catch(error => {
        commit('API_REQUEST_ERROR', {
          title: 'ERROR',
          type: 'error',
          text: apiErrorToHTML((error.response) ? error.response.data : error.response, this)
        })
        throw error
      })
    }
  },
  getters: {
    apiURL () {
      return Vue.config.app.API_URL
    },
    apiHeaders (state) {
      var outputToken = {}
      if (state.auth.token && state.auth.token !== 'null') {
        outputToken.Authorization = 'Token ' + state.auth.token
      } else if (state.auth.tokenJwt && state.auth.tokenJwt !== 'null') {
        outputToken.Authorization = 'Bearer ' + state.auth.tokenJwt
      }
      if (!state.auth.authenticated) { return {} }
      return outputToken
    },
    pageSize (state) { return state.pageSize },
    indicatorsApi () {
      return Vue.config.app.INDICATORS_API
    },
    indicatorsHeaders (state) {
      return { 'Authorization': 'Token ' + Vue.config.app.INDICATORS_TOKEN }
    }
  }
})

function apiErrorToHTML (error) {
  var html = '<div></div>'
  if (!error) return ''
  if (typeof error === 'string' || error instanceof String) return error
  Object.keys(error).forEach(key => {
    html += `<label>${key}</label>`

    if (error[key].isArray) {
      html += `<ul><li>${error[key].join('</li><li>')}</li></ul>`
    } else {
      html += `<div>${error[key]}</div>`
    }
  })
  return html
}

/* function apiErrorToHTML (error, context) {
  var html = ''
  if (error.data) {
    Object.keys(error.data).forEach(key => {
      html += `<label>${key}</label>`

      if (Array.isArray(error.data[key])) {
        html += `<ul><li>${error.data[key].join('</li><li>')}</li></ul>`
      } else {
        var include = false
        Object.keys(error.data[key]).forEach(childKey => {
          if (Array.isArray(error.data[key][childKey])) {
            html += `<ul><li>${error.data[key][childKey].join('</li><li>')}</li></ul>`
          } else {
            include = true
          }
        })
        if (include) {
          html += `<div>${error.data[key]}</div>`
        }
      }
    })
  } else {
    html = context._vm.$t(error.status.toString())
  }
  return html
}
 */



// WEBPACK FOOTER //
// ./src/store/index.js